export default __webpack_public_path__ + "static/New_Zealands_feisty_feathered_patient-a5a4b91f44bb2e5f948f6442faf377d0.jpg";